<template>
  <div class="pay">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div class="table-agile-info">
            <p>&nbsp;</p>
            <el-alert type="success" title="本页为历史数据，仅供参考。2022年前的未确认交易尚未全部同步至新版“订单系统”，可通过手工报账导入新系统。" style="margin-bottom:10px" />
            <jm-tableList
              :url="`index/order/student/crmid/${this.$route.params.crmid}`"
              :refresh.sync="refresh">
              <el-table-column
                slot="order_status"
                label="支付状态" >
                <template slot-scope="scope">
                  <span :class="[scope.row.order_status === '已付款' ? 'red' : '']">{{ scope.row.order_status }}</span>
                </template>
              </el-table-column>
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';

export default {
  data() {
    return {
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  },
  mounted() {
  }
};
</script>
<style scoped>
  .pay .red{
    color: #f00;
  }
</style>
